import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableFooter,
  IconButton,
  Button,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import formatDate from "../../../utils/formatDate";
import useModalStrip from "../../../global-hooks/useModalStrip";


const UserListData = ({ data, changeUserStatus }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [showPassword, setShowPassword] = useState({});
  const { showModalStrip } = useModalStrip();
  const navigate = useNavigate();

  // const currentData = data?.users?.slice(
  //   page * rowsPerPage,
  //   page * rowsPerPage + rowsPerPage
  // );

  const togglePasswordVisibility = (id) => {
    setShowPassword((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleCopy = (uniqueID) => {
    const fullURL = `${window.location.origin}/user-form/${uniqueID}`;
    navigator.clipboard
      .writeText(fullURL)
      .then(() => {
        showModalStrip("info", "URL copied to clipboard!", 5000);
      })
      .catch((err) => console.error("Failed to copy URL:", err));
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };





  if (!data?.users?.length) {
    return <div>No users found.</div>;
  }

  return (
    <Paper style={{ maxHeight: "70vh", overflow: "auto" }}>
      <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/create-user")}
        >
          Add User
        </Button>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>UserId</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Name</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Mobile</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Email</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>DOB</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Password</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.users?.map((user) => (
              <TableRow key={user._id}>
                <TableCell
                  onClick={() => navigate(`/view-user/${user._id}`)}
                  style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
                >
                  {user.userId}
                </TableCell>
                <TableCell>{user.name}</TableCell>
                <TableCell>{user.mobile}</TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{formatDate(user.dob)}</TableCell>
                <TableCell style={{ width: "150px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span>{showPassword[user._id] ? user.password : "*************"}</span>
                    <IconButton
                      onClick={() => togglePasswordVisibility(user._id)}
                      size="small"
                    >
                      {showPassword[user._id] ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </div>
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() => navigate(`/update-user/${user._id}`)}
                    size="small"
                  >
                    <FontAwesomeIcon icon={faPenToSquare} title="Update" />
                  </IconButton>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={user?.isActive}      // Set the switch's position
                        // Handle the switch's state change
                        onChange={() => changeUserStatus(user._id, user?.isActive === true ? 'Disable' : "Enable")}
                        color="primary"           // You can change the color (default, primary, secondary, etc.)
                      />
                    }
                    sx={{ marginLeft: 2 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          {/* <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                count={data?.users?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter> */}
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default UserListData;
